

import { GlobalResponseObject } from '../../common/index';
import { RoleDto } from './role.dto';

export class RoleResponse extends GlobalResponseObject {
    data?: RoleDto[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RoleDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}